import * as $ from 'jquery';

export default class ProgressService {


    private static dummyProgressId;
    private static maxProgress = 50;
    private static waitProgress = 96;
    private static failsafeTimeout = 20000;

    static dummyPogress() {
        let perc = ProgressService.maxProgress;
        this.dummyProgressId = setInterval(() => {
            if (perc < ProgressService.waitProgress) {
                perc += 1;
                ProgressService.showProgress(perc);
            }
        }, 500);
        setTimeout(() => {
            if (this.dummyProgressId) {
                clearInterval(this.dummyProgressId);
            }
        }, ProgressService.failsafeTimeout);
    }

    static stopProgress() {
        clearInterval(this.dummyProgressId);
        this.showProgress(98);
        setTimeout(() => {
            this.showProgress(100);
            setTimeout(() => {
                this.hideProgress();
            }, 500);
        }, 500);
    }

    static hideProgress() {
        $(".upload-bg").remove();
    }


    static showProgress(percentage: number) {
        $('.progress-content .progress-bar').attr('aria-valuenow', percentage).css('width', percentage + "%");
        $('.progress-content .progress-bar')[0].innerText = percentage + "%";
    }

    static progress() {
        var myXhr = $.ajaxSettings.xhr();
        if (myXhr.upload) {
            myXhr.upload.addEventListener('progress',
                function (e) {
                    if (e.lengthComputable) {
                        var max = e.total;
                        var current = e.loaded;

                        var Percentage = Math.floor((current * ProgressService.maxProgress) / max);

                        if (Percentage <= ProgressService.maxProgress) {
                            if ($(".upload-bg").length == 0) {
                                $('<div class="upload-bg">' +
                                    '<div class="progress-content">' +
                                    '<div class="progress-bar" role="progressbar" style="width: 5%;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">0%</div>' +
                                    '</div>' +
                                    '<div class="progress-bar-title">' + (self as any).translations.please + '</div>' +
                                    '</div>').appendTo("body");

                            }

                        }

                        ProgressService.showProgress(Percentage);

                        if (Percentage >= ProgressService.maxProgress) {
                            // process completed
                            //$(".upload-bg").remove();
                            ProgressService.dummyPogress();

                        }
                    }
                }, false);
        }
        return myXhr;
    }
}